import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import InputField from "@components/input-field/input-field";
import { useMetaTags } from "@components/meta-tags/hooks/use-meta-tags";
import QueryHandler from "@components/query-handler/query-handler";

import { IReward } from "@typings/global.types";

import { useGetExerciseEntrypointQuery } from "../../api/exercise-entrypoint";

function Wrapper() {
  const { setMetaTags } = useMetaTags();
  const intl = useIntl();
  const { data, isLoading } = useGetExerciseEntrypointQuery({
    exerciseId: 0,
  });

  const isAuthorized = Boolean(data);

  if (!isLoading) {
    let title = intl.formatMessage({ id: "meta-title-process-unauthorized" });
    let description = intl.formatMessage({
      id: "meta-description-process-unauthorized",
    });
    if (isAuthorized) {
      title = intl.formatMessage(
        { id: "meta-title-process-authorized" },
        {
          exercise: data?.user.currentExercise,
          lesson: data?.user.currentLesson,
        },
      );
      description = intl.formatMessage({
        // todo same as meta-description-process-unauthorized
        id: "meta-description-process-unauthorized",
      });
    }
    setMetaTags({
      title,
      description,
    });
  }

  const currentUrl = window.location.href;
  const isDevEnvironment =
    currentUrl.includes("dev") || currentUrl.includes("sand");

  if (isDevEnvironment) {
    console.log("data", data);
  }

  return (
    <QueryHandler isLoading={isLoading}>
      <InputField key={data?.exercise.id} data={data} />
    </QueryHandler>
  );
}
export default Wrapper;
